import { UndoRedoManager } from '@/utilityModels/undoRedoManager';

import * as def from '@/definitions'
import { ArrayHelper } from '@/helper/arrayHelper';
import { ShapeInfo } from '@/data/productCategory/product/paper/frameInfo/shapeInfo/shapeInfo';
import { CompatibleHelper } from '@/helper/compatibleHelper';
import { ImageHelper } from '@/helper/imageHelper';

/** フレーム枠形状 */

export class Shape
{
    // 形状タイプ
    // 0: 通常
    // 1: CD/DVD...2重にボーダーを表示する。
    private _type : number = 0;
    public get type() { return this._type; }
    public set type(type) { this._type = type; }

    // 角の丸み
    private _cornerRadius : number = 0;
    public get cornerRadius() { return this._cornerRadius; }
    public set cornerRadius(cornerRadius) { this._cornerRadius = cornerRadius; }

    // 内側の円の半径
    private _innerCircleRadius : number = 0;
    public get innerCircleRadius() { return this._innerCircleRadius; }
    public set innerCircleRadius(innerCircleRadius) { this._innerCircleRadius = innerCircleRadius; }

    // 表面フレームにSVG画像を表示するか
    private _hasFaceImage : boolean = false;
    public get hasFaceImage() { return this._hasFaceImage; }
    public set hasFaceImage(hasFaceImage) { this._hasFaceImage = hasFaceImage; }

    // 表面フレームのSVG画像
    private _faceImage : string = "";
    public get faceImage() { return this._faceImage; }
    public set faceImage(faceImage) { this._faceImage = faceImage; }

    // 裏面フレームにSVG画像を表示するか
    private _hasReverseImage : boolean = false;
    public get hasReverseImage() { return this._hasReverseImage; }
    public set hasReverseImage(hasReverseImage) { this._hasReverseImage = hasReverseImage; }

    // 裏面フレームのSVG画像(base64)
    private _reverseImage : string = "";
    public get reverseImage() { return this._reverseImage; }
    public set reverseImage(reverseImage) { this._reverseImage = reverseImage; }

    // フレーム形状情報を元にしてフレーム形状を作る。
    public static createFromShapeIndo(shapeInfo : ShapeInfo, width : number, height : number)
    {
        // 新規フレーム形状作成
        var shape = new Shape();

        if(shapeInfo.name == "rect")
        {
            shape.cornerRadius = 0;
            shape.type = 0;
        }
        else if(shapeInfo.name == "ellipse")
        {
            shape.cornerRadius = Math.min(width, height) / 2;
            shape.type = 0;
        }
        else if(shapeInfo.name == "8cmCD-R" || shapeInfo.name == "CD_DVD")
        {
            shape.cornerRadius = Math.min(width, height) / 2;
            shape.innerCircleRadius = shapeInfo.innerDiameter / 2;
            shape.type = 1;
        }
        else // "roundRect"
        {
            //! 旧コードをみると、diameterをradiusとして解釈している
            shape.cornerRadius = shapeInfo.innerDiameter;
            shape.type = 0;
        }
        shape.hasFaceImage = shapeInfo.useFrontFxg == "1" || shapeInfo.useFrontFxg == 1;
        shape.hasReverseImage = shapeInfo.useBackFxg == "1" || shapeInfo.useBackFxg == 1;

        // フレーム画像セット
        if(shape.hasFaceImage)
        {
            if(shapeInfo.imageFormat == 0)
            {
                var frontTag = CompatibleHelper.convertCompressedEncodedImageToSvg(shapeInfo.frontFxg);
                if(frontTag != null && frontTag != "")
                {
                    // データをbase64SVGに変換する *バックレイヤー削除
                    shape.faceImage = ImageHelper.convertSVGTagToBase64(CompatibleHelper.removeBacklayerFromSvg(frontTag));
                }
            }
        }

        if(shape.hasReverseImage)
        {
            if(shapeInfo.imageFormat == 0)
            {
                var backTag = CompatibleHelper.convertCompressedEncodedImageToSvg(shapeInfo.backFxg);
                if(backTag != null && backTag != "")
                {
                    // データをbase64SVGに変換する *バックレイヤー削除
                    shape.reverseImage = ImageHelper.convertSVGTagToBase64(CompatibleHelper.removeBacklayerFromSvg(backTag));
                }
            }
        }
        
        return shape;
    }

    // JSON
    public toJSON()
    {
        // JSONパース用オブジェクト
        var cloneObj = {
            type : this.type,
            cornerRadius : this.cornerRadius,
            innerCircleRadius : this.innerCircleRadius,
            hasFaceImage : this.hasFaceImage,
            faceImage : this.faceImage,
            hasReverseImage : this.hasReverseImage,
            reverseImage : this.reverseImage
        };

        return cloneObj;
    }

    public static createFromJsonData(jsonData : any)
    {
        var shape = new Shape();
        if(jsonData.type) { shape.type = jsonData.type; }
        if(jsonData.cornerRadius) { shape.cornerRadius = jsonData.cornerRadius; }
        if(jsonData.innerCircleRadius) { shape.innerCircleRadius = jsonData.innerCircleRadius; }
        if(jsonData.hasFaceImage) { shape.hasFaceImage = jsonData.hasFaceImage; }
        if(jsonData.faceImage) { shape.faceImage = jsonData.faceImage; }
        if(jsonData.hasReverseImage) { shape.hasReverseImage = jsonData.hasReverseImage; }
        if(jsonData.reverseImage) { shape.reverseImage = jsonData.reverseImage; }
        return shape;
    }
}